import { render, staticRenderFns } from "./HmOcrTemplateDetails.vue?vue&type=template&id=2a70caae&scoped=true&"
import script from "./HmOcrTemplateDetails.vue?vue&type=script&lang=js&"
export * from "./HmOcrTemplateDetails.vue?vue&type=script&lang=js&"
import style0 from "./HmOcrTemplateDetails.vue?vue&type=style&index=0&id=2a70caae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a70caae",
  null
  
)

component.options.__file = "HmOcrTemplateDetails.vue"
export default component.exports